import { RolesColumn } from '../../../../../../../../model/rolesAndPerms.model';

export const UsersAssignedCell = ({ row, column }: { row: any; column: RolesColumn }) => {
  return <span>{row[column.id as keyof typeof row]} Users</span>;
};
